import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import { Styles } from "./styles/event.js";

import axios from "axios";
import { Constant, imageDomain } from "../../helper/Constants.js";

class Events extends Component {
  state = {
    events: [],
    loading: true,
    error: null,
    page: 1,
    limit: 9, // ✅ 3 cards per row
    totalPages: 1,
    totalDocs: 0,
  };

  componentDidMount() {
    const { page, limit } = this.state;
    this.fetchEvents(page, limit);
  }

  formatReadableDate = (dateStr = "") => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";

    const monthNames = [
      "Jan","Feb","Mar","Apr","May","Jun",
      "Jul","Aug","Sep","Oct","Nov","Dec",
    ];

    return `${d.getDate()} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
  };

  fetchEvents = async (page = 1, limit = 9) => {
    this.setState({ loading: true, error: null });

    try {
      const baseUrl =
        Constant?.getUrls?.getAllEvents || "/event";

      const resp = await axios.get(
        `${baseUrl}?page=${page}&limit=${limit}`
      );

      const payload = resp?.data || {};
      const list = Array.isArray(payload.data) ? payload.data : [];
      const pagination = payload.pagination || {};

      const totalDocs = pagination.total || list.length || 0;
      const totalPages =
        pagination.totalpage || Math.ceil(totalDocs / limit);

      this.setState({
        events: list,
        loading: false,
        page: pagination.page || page,
        totalPages,
        totalDocs,
      });
    } catch (err) {
      this.setState({
        loading: false,
        error: "Failed to fetch events",
        events: [],
      });
    }
  };

  handlePageChange = (newPage) => {
    const { totalPages, limit } = this.state;
    if (newPage < 1 || newPage > totalPages) return;
    this.fetchEvents(newPage, limit);
  };

  getImageUrl = (imgPath) => {
    if (!imgPath)
      return process.env.PUBLIC_URL + "/assets/images/default-event.jpg";
    if (/^https?:\/\//i.test(imgPath)) return imgPath;

    return imageDomain.replace(/\/+$/, "") + "/" + imgPath.replace(/^\/+/, "");
  };

  getShortText = (html = "", maxLen = 120) => {
    const text = html.replace(/<[^>]*>?/gm, "");
    return text.length > maxLen ? text.substring(0, maxLen) + "..." : text;
  };

  render() {
    const { events, loading, error, page, totalPages } = this.state;

    return (
      <Styles>
        <div className="main-wrapper event-page">
          <Header />
          <BreadcrumbBox title="Events" />

          <section className="event-page-area">
            <Container>
              {loading ? (
                <p className="text-center">Loading...</p>
              ) : error ? (
                <p className="text-center text-danger">{error}</p>
              ) : events.length === 0 ? (
                <p className="text-center">No events found.</p>
              ) : (
                <Row>
                  {events.map((event, i) => {
                    const link = `/event-details/${event._id}`;
                    const title = event.name || "Event Title";
                    const location = event.event_venue || "";
                    const time = event.event_time || event.event_type || "";
                    const readableDate = this.formatReadableDate(event.event_date);
                    const desc = this.getShortText(event.event_details || "");
                    const image = this.getImageUrl(event.image);

                    return (
                      <Col lg="4" md="6" sm="12" key={event._id || i}>
                        <div className="modern-event-card">
                          <div className="event-image-wrapper">
                            <Link to={link}>
                              <img src={image} alt={title} />
                            </Link>

                            {readableDate && (
                              <div className="event-date-badge">
                                {readableDate}
                              </div>
                            )}
                          </div>

                          <div className="event-card-body">
                            {/* <span className="event-category">
                              Dance & Music
                            </span> */}

                            <h5 className="event-title">
                              <Link to={link}>{title}</Link>
                            </h5>

                            <ul className="event-meta">
                              {location && (
                                <li>
                                  <i className="las la-map-marker"></i>{" "}
                                  {location}
                                </li>
                              )}
                              {time && (
                                <li>
                                  <i className="las la-clock"></i> {time}
                                </li>
                              )}
                            </ul>

                            <p className="event-desc">{desc}</p>

                            <div className="event-actions">
                              <Link to={link} className="btn-view">
                                View Details
                              </Link>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              )}

              {/* ✅ PAGINATION (UNCHANGED) */}
              {!loading && totalPages > 1 && (
                <Row>
                  <Col md="12" className="text-center">
                    <ul className="pagination-box list-unstyled list-inline">
                      <li className="list-inline-item">
                        <a onClick={() => this.handlePageChange(1)}>
                          <i className="las la-angle-double-left"></i>
                        </a>
                      </li>

                      {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter((p) => {
                          if (p === 1 || p === totalPages) return true;
                          if (Math.abs(p - page) <= 2) return true;
                          return false;
                        })
                        .map((p, index, arr) => {
                          const prev = arr[index - 1];
                          const gap = prev && p - prev > 1;
                          return (
                            <React.Fragment key={p}>
                              {gap && (
                                <li className="list-inline-item">
                                  <span>…</span>
                                </li>
                              )}
                              <li
                                className={`list-inline-item ${
                                  p === page ? "active" : ""
                                }`}
                              >
                                <a onClick={() => this.handlePageChange(p)}>
                                  {p}
                                </a>
                              </li>
                            </React.Fragment>
                          );
                        })}

                      <li className="list-inline-item">
                        <a onClick={() => this.handlePageChange(totalPages)}>
                          <i className="las la-angle-double-right"></i>
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              )}
            </Container>
          </section>

          <Footer />
        </div>
      </Styles>
    );
  }
}

export default Events;


// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import { Container, Row, Col } from "react-bootstrap";
// import Header from "../../components/Header";
// import { BreadcrumbBox } from "../../components/common/Breadcrumb";
// import CourseSidebar from "../courses/components/CourseSidebar";
// import Footer from "../../components/Footer";
// import { Styles } from "./styles/event.js";

// import axios from "axios";
// import { Constant, imageDomain } from "../../helper/Constants.js";

// class Events extends Component {
//   state = {
//     events: [],
//     loading: true,
//     error: null,
//     page: 1,
//     limit: 8,
//     totalPages: 1,
//     totalDocs: 0,
//   };

//   componentDidMount() {
//     const { page, limit } = this.state;
//     this.fetchEvents(page, limit);
//   }

//   // Convert backend date into a readable format
//   formatReadableDate = (dateStr = "") => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr);
//     if (isNaN(d.getTime())) return "";

//     const day = d.getDate();
//     const monthNames = [
//       "January",
//       "February",
//       "March",
//       "April",
//       "May",
//       "June",
//       "July",
//       "August",
//       "September",
//       "October",
//       "November",
//       "December",
//     ];
//     const month = monthNames[d.getMonth()];
//     const year = d.getFullYear();

//     return `${day} ${month} ${year}`;
//   };

//   fetchEvents = async (page = 1, limit = 8) => {
//     this.setState({ loading: true, error: null });

//     try {
//       const baseUrl =
//         (Constant && Constant.getUrls && Constant.getUrls.getAllEvents) ||
//         "/event";

//       const resp = await axios.get(`${baseUrl}?page=${page}&limit=${limit}`);
//       const payload = resp?.data || {};
//       const list = Array.isArray(payload.data) ? payload.data : [];
//       const pagination = payload.pagination || {};

//       const totalDocs = pagination.total || list.length || 0;
//       const totalPages =
//         pagination.totalpage || (limit ? Math.ceil(totalDocs / limit) : 1);

//       this.setState({
//         events: list,
//         loading: false,
//         page: pagination.page || page,
//         totalPages,
//         totalDocs,
//       });
//     } catch (err) {
//       this.setState({
//         loading: false,
//         error: "Failed to fetch events",
//         events: [],
//       });
//     }
//   };

//   handlePageChange = (newPage) => {
//     const { totalPages, limit } = this.state;
//     if (newPage < 1 || newPage > totalPages) return;
//     this.fetchEvents(newPage, limit);
//   };

//   getImageUrl = (imgPath) => {
//     if (!imgPath)
//       return process.env.PUBLIC_URL + "/assets/images/default-event.jpg";
//     if (/^https?:\/\//i.test(imgPath)) return imgPath;

//     return imageDomain.replace(/\/+$/, "") + "/" + imgPath.replace(/^\/+/, "");
//   };

//   getShortText = (html = "", maxLen = 180) => {
//     const text = html.replace(/<[^>]*>?/gm, "");
//     return text.length > maxLen ? text.substring(0, maxLen) + "..." : text;
//   };

//   render() {
//     const { events, loading, error, page, totalPages } = this.state;

//     return (
//       <Styles>
//         <div className="main-wrapper event-page">
//           <Header />
//           <BreadcrumbBox title="Events" />

//           <section className="event-page-area">
//             <Container>
//               <Row >
//                 <Col lg="12" md="3" sm="3" style={{marginLeft: "40px"}}>
//                   {loading ? (
//                     <div className="text-center">
//                       <p>Loading...</p>
//                     </div>
//                   ) : error ? (
//                     <div className="text-center">
//                       <p style={{ color: "red" }}>{error}</p>
//                     </div>
//                   ) : events.length === 0 ? (
//                     <div className="text-center">
//                       <p>No events found.</p>
//                     </div>
//                   ) : (
//                     events.map((event, i) => {
//                       const link = `/event-details/${event._id}`;
//                       const title = event.name || "Event Title";
//                       const location = event.event_venue || "";
//                       const time = event.event_time || event.event_type || "";
//                       const readableDate = this.formatReadableDate(
//                         event.event_date
//                       );
//                       const desc = this.getShortText(event.event_details || "");
//                       const image = this.getImageUrl(event.image);

//                       return (
//                         <div className="event-box" key={event._id || i}>
//                           <Row>
//                             <Col xl="3" lg="4" md="0">
//                               <div className="event-img">
//                                 <Link to={link}>
//                                   <img
//                                     src={image}
//                                     alt={title}
//                                     className="img-fluid"
//                                   />
//                                 </Link>
//                               </div>
//                             </Col>

//                             <Col xl="" lg="8" md="12">
//                              <Link to={link}>
//                               <div className="event-content">
//                                 <div className="content-box">
//                                   <Row>
//                                     <Col md="9">
//                                       <div className="event-title">
//                                         <h6>
//                                           <Link to={link}>{title}</Link>
//                                         </h6>
//                                       </div>

//                                       <div className="event-time-location">
//                                         <ul className="list-unstyled list-inline">
//                                           {time && (
//                                             <li className="list-inline-item">
//                                               <i className="las la-clock"></i>{" "}
//                                               {time}
//                                             </li>
//                                           )}
//                                           {location && (
//                                             <li className="list-inline-item">
//                                               <i className="las la-map-marker"></i>{" "}
//                                               {location}
//                                             </li>
//                                           )}
//                                         </ul>
//                                       </div>

//                                       <div className="event-desc">
//                                         <p>{desc}</p>
//                                       </div>
//                                     </Col>

//                                     <Col md="3" className="text-center">
//                                       <div className="event-date">
//                                         <p>{readableDate}</p>
//                                       </div>

//                                       {/* Join Now button removed */}
//                                     </Col>
//                                   </Row>
//                                 </div>
//                               </div>
//                               </Link>
//                             </Col>
//                           </Row>
//                         </div>
//                       );
//                     })
//                   )}

//                   {/* Pagination */}
//                   {!loading && totalPages > 1 && (
//                     <Col md="12" className="text-center">
//                       <ul className="pagination-box list-unstyled list-inline">
//                         {/* First page */}
//                         <li className="list-inline-item">
//                           <a onClick={() => this.handlePageChange(1)}>
//                             <i className="las la-angle-double-left"></i>
//                           </a>
//                         </li>

//                         {/* Page numbers with ellipsis */}
//                         {Array.from({ length: totalPages }, (_, idx) => idx + 1)
//                           .filter((p) => {
//                             if (p === 1 || p === totalPages) return true;
//                             if (Math.abs(p - page) <= 2) return true;
//                             return false;
//                           })
//                           .map((p, index, arr) => {
//                             const prev = arr[index - 1];
//                             const gap = prev && p - prev > 1;
//                             return (
//                               <React.Fragment key={p}>
//                                 {gap && (
//                                   <li className="list-inline-item">
//                                     <a
//                                       style={{
//                                         border: "none",
//                                         background: "transparent",
//                                       }}
//                                     >
//                                       …
//                                     </a>
//                                   </li>
//                                 )}
//                                 <li
//                                   className={`list-inline-item ${
//                                     p === page ? "active" : ""
//                                   }`}
//                                 >
//                                   <a onClick={() => this.handlePageChange(p)}>
//                                     {p}
//                                   </a>
//                                 </li>
//                               </React.Fragment>
//                             );
//                           })}

//                         {/* Last page */}
//                         <li className="list-inline-item">
//                           <a onClick={() => this.handlePageChange(totalPages)}>
//                             <i className="las la-angle-double-right"></i>
//                           </a>
//                         </li>
//                       </ul>
//                     </Col>
//                   )}
//                 </Col>

//                 {/* <Col lg="3" md="0">
//                   <CourseSidebar />
//                 </Col> */}
//               </Row>
//             </Container>
//           </section>

//           <Footer />
//         </div>
//       </Styles>
//     );
//   }
// }

// export default Events;
